export const configuration = {
 apiUrl: 'http://10.10.0.13:8000/api/v1/',
 fileUrl: 'http://10.10.0.200:8030/api/v1/',
};
